import { Map, fromJS } from 'immutable'
import {
  SET_PM_LIST,
  SET_MULTIPLE_PM_LISTS,
  SET_PM_LIST_ERROR,
  SET_PM_LIST_PROCESSING,
  RESET_PM_LIST,
} from './actions'

export const initialState = Map()

/**
 * PM List reducer
 */
export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SET_PM_LIST: {
      const { listId, data, processing = false } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([listId, 'processing'], processing)
          .setIn([listId, 'dataCreated'], new Date())
          .setIn([listId, 'data'], fromJS(data))
          .deleteIn([listId, 'error'])
          .deleteIn([listId, 'errorCreated'])
      })
    }
    case SET_MULTIPLE_PM_LISTS: {
      const { lists = [], processing = false } = action.payload
      return state.withMutations((mutableState) => {
        lists.forEach((pmList) => {
          const listId = Map.isMap(pmList) ? pmList.get('id') : pmList.id
          if (listId) {
            const listData = Map.isMap(pmList) ? pmList : fromJS(pmList)
            mutableState
              .setIn([listId, 'processing'], processing)
              .setIn([listId, 'dataCreated'], new Date())
              .setIn([listId, 'data'], listData)
              .deleteIn([listId, 'error'])
              .deleteIn([listId, 'errorCreated'])
          }
        })
      })
    }
    case SET_PM_LIST_PROCESSING: {
      const { listId, processing = true } = action.payload
      return state.setIn([listId, 'processing'], processing)
    }
    case SET_PM_LIST_ERROR: {
      const { listId, error } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([listId, 'processing'], false)
          .deleteIn([listId, 'data'])
          .setIn([listId, 'error'], error)
          .setIn([listId, 'errorCreated'], new Date())
      })
    }
    case RESET_PM_LIST:
      return initialState
    default:
      return state
  }
}
